import React from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { UserStatus, UserRole } from '../types/user';

const StatusBanner: React.FC = () => {
  const { user } = useAuth();
  
  // Only show banner for pending clients
  if (!user || 
      user.role !== UserRole.CLIENT || 
      user.status !== UserStatus.PENDING) {
    return null;
  }
  
  return (
    <Box sx={{ width: '100%', marginBottom: 2 }}>
      <Alert 
        severity="warning" 
        sx={{ 
          py: 1.5, 
          fontWeight: 'medium'
        }}
      >
        Your account is pending approval. You won't be able to place orders until an administrator approves your account.
      </Alert>
    </Box>
  );
};

export default StatusBanner; 